import { useCallback } from 'react';

import { useAppDispatch } from '@/store/hooks';
import { showToast } from '@/store/slices/toastSlice';

export function getErrorMessage(error: unknown): string {
  if (!error) return 'Something went wrong';
  if (typeof error === 'object') {
    const data = (error as Record<string, unknown>).data;
    if (typeof data === 'object' && data && 'message' in data) {
      return String((data as Record<string, unknown>).message);
    }
    if ('message' in error) return String((error as Record<string, unknown>).message);
  }
  return 'Something went wrong';
}

export function useToast() {
  const dispatch = useAppDispatch();

  const success = useCallback(
    (message: string, duration?: number) =>
      dispatch(showToast({ message, severity: 'success', duration })),
    [dispatch],
  );

  const error = useCallback(
    (message: string, duration?: number) =>
      dispatch(showToast({ message, severity: 'error', duration })),
    [dispatch],
  );

  const warn = useCallback(
    (message: string, duration?: number) =>
      dispatch(showToast({ message, severity: 'warning', duration })),
    [dispatch],
  );

  const info = useCallback(
    (message: string, duration?: number) =>
      dispatch(showToast({ message, severity: 'info', duration })),
    [dispatch],
  );

  return { success, error, warn, info };
}
